class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.modal = this.closest('.search-modal');
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.suggestions=this.querySelector('[data-popular-search]');
    this.searchTerm = '';
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.querySelector('form.search').addEventListener('submit', this.onFormSubmit.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
    this.querySelector('button[type="reset"]').addEventListener('click', this.clear.bind(this));
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
      
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
   this.addEventListener('focusout', this.onFocusOut.bind(this));
//this.addEventListener('keyup', this.onKeyup.bind(this));
  //  this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-content")?.remove();
    }
    if(newSearchTerm != ''){
      this.querySelector('button[type="reset"]').classList.remove('hidden')
    }else{
      this.querySelector('button[type="reset"]').classList.add('hidden');
    }
    this.searchTerm = newSearchTerm;
    if (!this.searchTerm.length) {
      this.clear();
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
    focusElement = this
    trapFocusElements(this);
     setTimeout(() => {
          document.querySelector(this.querySelector("#Search-In-Template")).setAttribute('tabindex', '0');
          document.querySelector(this.querySelector("#Search-In-Template")).focus()
      }, 100);
  }
  
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    document.body.classList.add('predictive-search--focus');
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;
    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  } 

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) {
      this.clear(event);
      this.close(true);
    }
    event.preventDefault();
    switch (event.code) {
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }
 
  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
    if (selectedProduct) selectedProduct.click();
  }

  normalizeSearchTerm(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  isMarquiseEnFlorSearch(searchTerm) {
    const term = this.normalizeSearchTerm(searchTerm);
    // iPhone/Chrome autocorrect sometimes changes “marquise” to “márquese”.
    const hasModelWord = /\bmarq(?:uise|uese|ues|uis|uiz|uise)?\b/.test(term) || term.startsWith('marq');
    return hasModelWord && (term.includes(' flor') || term.endsWith('flor') || term === 'marquise' || term === 'marquese');
  }

  renderMarquiseEnFlorDirect() {
    const handle = 'anillo-de-compromiso-modelo-marquise-en-flor-oro-18k';
    const directKey = 'pnj-direct-' + handle;
    if (this.cachedResults[directKey]) {
      this.renderSearchResults(this.cachedResults[directKey]);
      return Promise.resolve();
    }

    return fetch(`${window.Shopify.routes.root}products/${handle}.js`)
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(product => {
        const money = (product.price / 100).toLocaleString('es-CL', {style:'currency', currency:'CLP', maximumFractionDigits:0});
        const image = product.featured_image || (product.images && product.images[0]) || '';
        const href = `${window.Shopify.routes.root}products/${product.handle}`;
        const safeTitle = product.title.replace(/"/g,'&quot;');
        const markup = `
          <div id="predictive-search-results-content" class="search-content">
            <div>
              <div class="treanding-products-list">
                <div class="heading-header flex"><span class="textMedium font-heading">Productos</span></div>
                <div class="grid-row">
                  <div class="grid-item-sm-6 grid-item-md-6 grid-item-l-3">
                    <a href="${href}" style="display:block;text-decoration:none;color:inherit">
                      ${image ? `<img src="${image}" alt="${safeTitle}" loading="eager" style="width:100%;height:auto;display:block">` : ''}
                      <div style="padding-top:12px">${product.title}</div>
                      <div style="padding-top:6px">${money}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>`;
        this.cachedResults[directKey] = markup;
        this.renderSearchResults(markup);
      });
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    // PNJ 04-SEP-2026: el modelo Marquise en Flor debe aparecer de inmediato,
    // incluso si Shopify Predictive Search aún no lo indexa o el móvil autocorrige
    // “marquise” como “márquese”. Para esta búsqueda evitamos resultados genéricos.
    if (this.isMarquiseEnFlorSearch(searchTerm)) {
      if (this.suggestions) this.suggestions.classList.add("hidden");
      this.renderMarquiseEnFlorDirect().catch(() => {
        // Si el producto no pudiera cargarse, recién entonces usamos Shopify.
        this.getShopifySearchResults(searchTerm, queryKey);
      });
      if (this.modal) this.modal.classList.add('searching');
      return;
    }
    
    if (this.cachedResults[queryKey]) {
        if(this.suggestions){
          this.suggestions.classList.add("hidden")
        }
      this.renderSearchResults(this.cachedResults[queryKey]);
      if (this.modal) this.modal.classList.add('searching');
      return;
    }
    this.getShopifySearchResults(searchTerm, queryKey);
  }

  getShopifySearchResults(searchTerm, queryKey) {
    fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`)
      .then((response) => { 
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const section = parsed.querySelector('#shopify-section-predictive-search');
        const resultsMarkup = section ? section.innerHTML : '';
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        if(this.suggestions){
          this.suggestions.classList.add("hidden")
        }
        this.renderSearchResults(resultsMarkup);

         if (animationCheck) {
          if (AOS) {
               AOS.refreshHard()
            }
          }
          
          
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      }); 
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('[data-predictive-search]');
    this.setLiveRegionText(storeLoader);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statuscontent) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    if(this.suggestions){
      this.suggestions.classList.add("populat-content-blur")
    }
    this.statusElement.innerHTML = statuscontent;
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);  
    this.setLiveRegionResults();
  }

  setLiveRegionResults() { 
    this.removeAttribute('loading');
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.input.setAttribute('aria-expanded', false);
    document.body.classList.remove('predictive-search--focus');
  }

  clear(event) {
    this.input.value = '';
    this.querySelector('[data-predictive-search]').innerHTML=''
    this.input.focus();
    if(this.suggestions){
        this.suggestions.classList.remove("hidden","populat-content-blur")
    }
    if (this.modal) this.modal.classList.remove('searching');
  }
}

customElements.define('predictive-search', PredictiveSearch);